import { useFetch } from "@common/hooks/useFetch";
import { useState } from "react";
import { ROUTES } from "@constants";
import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { customerDetailsRoute, updateTermsAndConditionRoute, updateTermsAndConditionCrossSellRoute } from "@api-routes";
import { getStateToPayload as getCustomerDetailsStateToPayload } from "@features/customerDetails/mappers/updateCustomerDetailsMapper";
import { ICustomerDetailsResponse } from "@features/customerDetails/mappers/getCustomerDetailsMapper";
import { getStateToPayload as getTermsAndConditionsStateToPayload } from "@features/customerDetails/mappers/updateTermsAmdConditionsMapper";
import { fixUrlLanguage } from "@utils/changeLanguage";
import { IBooleanResponse } from "@common/IBooleanResponse";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";
import { IError } from "src/itsf/fetch/fetcherUtils";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const useUpdateCustomerDetails = (pushHistory: (url: string) => void) => {
    const [updateCustomerDetailsState, { put }] = useFetch();
    const [updateCustomerDetailsError, setUpdateCustomerDetailsError] = useState<IError>();

    const updateCustomerDetails = (
        customerDetails: ICustomerDetails,
        privacyPolicyValue: boolean,
        setEmailError: (errorMessage?: string) => void
    ) => {
        setEmailError();
        setUpdateCustomerDetailsError(undefined);

        if (!keycloakUtils.isAuthenticated()) {

            const fullNumber = "+".concat(customerDetails.owner.mobileNumber || "");
            const parsedNumber = phoneUtil.parseAndKeepRawInput(fullNumber);
            
            const countryCode = parsedNumber.getCountryCode();
            const msisdn = parsedNumber.getNationalNumber();

            customerDetails.owner.countryCode = countryCode+"";
            customerDetails.owner.mobileNumber = msisdn+"";



            return put<ICustomerDetailsResponse>(customerDetailsRoute(), {
                body: getCustomerDetailsStateToPayload(customerDetails),
                isSecured: keycloakUtils.isAuthenticated(),
                forwardError: true,
            })
                .then((customerDetailsResponse) => {
                    if (customerDetailsResponse) {
                        put<IBooleanResponse>(updateTermsAndConditionRoute(), {
                            body: getTermsAndConditionsStateToPayload(privacyPolicyValue),
                            isSecured: keycloakUtils.isAuthenticated(),
                        }).then((result) => {
                            if (result?.result) {
                                pushHistory(fixUrlLanguage(ROUTES.SUMMARY_PAGE_URL_EN));
                            }
                        });
                    }
                })
                .catch((error: IError | undefined) => {
                    if (error && error.errorCode === "USER_WITH_THIS_EMAIL_ALREADY_EXIST") {
                        setEmailError(error.errorMessage);
                    } else {
                        setUpdateCustomerDetailsError(error);
                    }
                });
        } else {
            return put<IBooleanResponse>(updateTermsAndConditionCrossSellRoute(), {
                body: getTermsAndConditionsStateToPayload(privacyPolicyValue),
                isSecured: keycloakUtils.isAuthenticated(),
            })
                .then((result) => {
                    if (result?.result) {
                        pushHistory(fixUrlLanguage(ROUTES.SUMMARY_PAGE_URL_EN));
                    }
                })
                .catch((error: IError | undefined) => {
                    setUpdateCustomerDetailsError(error);
                });
        }
    };

    return { updateCustomerDetailsState, updateCustomerDetailsError, updateCustomerDetails };
};
